import { AuthenticationResult } from '@azure/msal-browser';

import { loginRequest, msalInstance } from './authConfig';

export const getAccessToken = async (): Promise<string | undefined> => {
  const request = {
    ...loginRequest,
    account: msalInstance.getAllAccounts()[0],
  };
  await msalInstance.initialize();

  try {
    const { accessToken }: AuthenticationResult = await msalInstance.acquireTokenSilent(request);
    return accessToken;
  } catch (_) {
    await msalInstance.acquireTokenRedirect(request);
    return undefined;
  }
};
